import React from 'react';

import { SciPage } from 'enums';
import { useViewComponent } from 'hooks';

export const HelpPage: React.FC = () => {
  const HelpView = useViewComponent(SciPage.Help);
  return <HelpView />;
};
